<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  mounted () {
    window.addEventListener('unload', () => {
      if (this.$store.state.order) {
        localStorage.setItem('order', JSON.stringify(this.$store.state.order))
        localStorage.setItem('user', JSON.stringify(this.$store.state.user))
      }
    })
  }
}
</script>

<style>
#app {
  font-family: Roboto, Noto Sans CJK TC, "Microsoft YaHei", STHeiTi, sans-serif,
    simsun;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

#nav {
  padding: 30px;
}

#nav a {
  font-weight: bold;
  color: #2c3e50;
}

#nav a.router-link-exact-active {
  color: #42b983;
}
</style>
